 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import EBB from '@/components/ebb'
 import ALST from '@/components/alst'
 import PORTALIST from '@/components/portalist'
 import LOVE_1 from '@/components/love_1'
 import UNTITLED637 from '@/components/Untitled637'
 import UNTITLED638 from '@/components/Untitled638'
 import UNTITLED639 from '@/components/Untitled639'
 import UNTITLED640 from '@/components/Untitled640'
 import UNTITLED641 from '@/components/Untitled641'
 import UNTITLED642 from '@/components/Untitled642'
 import UNTITLED643 from '@/components/Untitled643'
 import UNTITLED644 from '@/components/Untitled644'
 import UNTITLED645 from '@/components/Untitled645'
 import UNTITLED646 from '@/components/Untitled646'
 import UNTITLED647 from '@/components/Untitled647'
 import UNTITLED648 from '@/components/Untitled648'
 import UNTITLED649 from '@/components/Untitled649'
 import UNTITLED650 from '@/components/Untitled650'
 import UNTITLED651 from '@/components/Untitled651'
 import UNTITLED652 from '@/components/Untitled652'
 import UNTITLED653 from '@/components/Untitled653'
 import UNTITLED654 from '@/components/Untitled654'
 import UNTITLED655 from '@/components/Untitled655'
 import UNTITLED656 from '@/components/Untitled656'
 import UNTITLED657 from '@/components/Untitled657'
 import UNTITLED658 from '@/components/Untitled658'
 import UNTITLED659 from '@/components/Untitled659'
 import UNTITLED660 from '@/components/Untitled660'
 import UNTITLED661 from '@/components/Untitled661'
 import UNTITLED662 from '@/components/Untitled662'
 import UNTITLED663 from '@/components/Untitled663'
 import UNTITLED664 from '@/components/Untitled664'
 import UNTITLED665 from '@/components/Untitled665'
 import UNTITLED666 from '@/components/Untitled666'
 import UNTITLED667 from '@/components/Untitled667'
 import UNTITLED668 from '@/components/Untitled668'
 import UNTITLED669 from '@/components/Untitled669'
 import UNTITLED670 from '@/components/Untitled670'
 import UNTITLED671 from '@/components/Untitled671'
 import UNTITLED672 from '@/components/Untitled672'
 import UNTITLED673 from '@/components/Untitled673'
 import UNTITLED674 from '@/components/Untitled674'
 import LOVE_2 from '@/components/love_2'
 import COPYRIGHT from '@/components/copyright'
 import AUBA from '@/components/auba'
 import ORIMAD from '@/components/ORIMad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/ebb",
 			"name" : "ebb",
 			"component" : EBB
 		},
 		{
 			"path" : "/alst",
 			"name" : "alst",
 			"component" : ALST
 		},
 		{
 			"path" : "/portalist",
 			"name" : "portalist",
 			"component" : PORTALIST
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/Untitled637",
 			"name" : "Untitled637",
 			"component" : UNTITLED637
 		},
 		{
 			"path" : "/Untitled638",
 			"name" : "Untitled638",
 			"component" : UNTITLED638
 		},
 		{
 			"path" : "/Untitled639",
 			"name" : "Untitled639",
 			"component" : UNTITLED639
 		},
 		{
 			"path" : "/Untitled640",
 			"name" : "Untitled640",
 			"component" : UNTITLED640
 		},
 		{
 			"path" : "/Untitled641",
 			"name" : "Untitled641",
 			"component" : UNTITLED641
 		},
 		{
 			"path" : "/Untitled642",
 			"name" : "Untitled642",
 			"component" : UNTITLED642
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js